<template>
  <sf-modal
    v-if="modalOpen"
    class-name="sf-border-box"
    size="wide"
    @close="close"
  >
    <template #title>{{ title }}</template>

    <template #body>
      <div ref="graph" class="report-graph"></div>
      <div v-if="description" class="report-graph-description-wrapper">
        <div class="sf-layer-rounded sf-layer-border-double sf-pad-3">
          <p v-dompurify-html="description"></p>
        </div>
      </div>
    </template>
  </sf-modal>
</template>

<script>
import { nextTick } from 'vue'

import { SfModal } from '@app/shared/vue/components/sf-modal'
import buildGraph from '../../../handlers/build-graph'

export default {
  components: {
    SfModal,
  },

  data() {
    return {
      title: null,
      description: null,
      modalOpen: false,
    }
  },

  methods: {
    openModal(context) {
      this.title = context.title
      this.description = context.description
      this.modalOpen = true

      nextTick(() => {
        buildGraph(context.graphData).render(this.$refs.graph)
      })
    },

    close() {
      this.modalOpen = false
    },
  },
}
</script>
